import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import workflowStatus from '../../../js/workflowStatus';
import { startCloningWorkflow } from '../../../js/actions/workflowActionCreators';
import CloneSourceForm from './cloneSourceForm';

const CloneSourcePage = React.createClass({
    propTypes: {
        image: PropTypes.object,
        setCloneCreationAsStarted: PropTypes.func.isRequired,
        workflowStatus: PropTypes.oneOf(_(workflowStatus).values()).isRequired
    },
    componentWillMount: function() {
        const { workflowStatus, setCloneCreationAsStarted } = this.props;
        if(workflowStatus !== workflowStatus.started) {
            setCloneCreationAsStarted();
        }
    },
    render: function () {
        return (
            <div className="content-container">
                <CloneSourceForm image={this.props.image} />
            </div>
        );
    }
});

CloneSourcePage.title = 'Source';

const mapStateToProps = (state, ownProps) => {
    const imageId = ownProps.location && ownProps.location.query && ownProps.location.query.imageId;
    const image = imageId && state.images.value.get(imageId);
    
    return {
        image: image,
        workflowStatus: state.app.cloneCreation.workflowStatus
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCloneCreationAsStarted: () => {
            dispatch(startCloningWorkflow());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CloneSourcePage);


// WEBPACK FOOTER //
// ./src/components/cloning/CloneSourcePage/index.jsx